import { connect } from 'react-redux';
import { alertActions, eventActions, userActions } from '../../actions';
import EventsDetail from '../../components/admin/EventsDetail';

const mapDispatchToProps = (dispatch) => {
  return {
    getEvents: () => {
      dispatch(eventActions.loadEvents())
    },
    updateUser: (user) => {
      dispatch(userActions.adminUpdateUser(user))
    },
    updateEvent: (e) => {
      dispatch(eventActions.adminUpdateEvent(e))
    },
    clearAlert: () => {
      dispatch(alertActions.clear())
    },
  }
}

function mapStateToProps(state, ownProps) {
  return {
    selectedEvent: state.selectedEvent.selectedEvent,
    selectedUser: state.selectedEvent.selectedUser,
    isLoading: state.events.isLoading
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventsDetail)
